import React, { useState, useEffect } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { Loader } from '../../../../common/components';
import { PunchInOutNavigation } from './Navigation/PunchInOutNavigation';
import OwnRoutes from './Own/OwnRoutes';
import TeamRoutes from './Team/TeamRoutes';
import { useGetBioMetricEmployeeList } from '@hooks';
import { getSignleStoredData, getStoredDataUsingKey } from '../../../../helpers/localStorageHelper';

const ListPunchInOutPage = loadable(() => import('./ListPunchInOutPage'), {
  fallback: <Loader />
});
const EditPunchInOutPage = loadable(() => import('./EditPunchInOutPage'), {
  fallback: <Loader />
});
const ViewPunchInOutPage = loadable(() => import('./ViewPunchInOutPage'), {
  fallback: <Loader />
});
const PunchInOutRoute = ({ t, alert }) => {
  const [employeeCanViewTeam, setEmployeeCanViewTeam] = useState([]);
  const [updateSelectedTab, setUpdateSelectedTab] = useState(
    getSignleStoredData('selectFilterData') || 'today'
  );

  // Get Employee List (0 = only active employee , 1 = all employee list)
  const { data: employeeList, isLoading: isEmployeeLoading } = useGetBioMetricEmployeeList();
  useEffect(() => {
    if (!isEmployeeLoading && employeeList?.data?.employee_list) {
      setEmployeeCanViewTeam(employeeList?.data?.employee_list?.length ?? 0);
    }
  }, [employeeList, isEmployeeLoading]);

  if (isEmployeeLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <PunchInOutNavigation
            t={t}
            employeeCanViewTeam={employeeCanViewTeam}
            updateSelectedTab={updateSelectedTab}
            setUpdateSelectedTab={setUpdateSelectedTab}
            alert={alert}
          />
        }>
        <Route index exact path="/list" element={<ListPunchInOutPage t={t} alert={alert} />} />
        {/* <Route index exact path="/edit/:id" element={<EditPunchInOutPage t={t} />} /> */}
        <Route index exact path="/view/:id" element={<ViewPunchInOutPage t={t} alert={alert} />} />
        {TeamRoutes({ t, employeeCanViewTeam, updateSelectedTab, setUpdateSelectedTab, alert })}
        {OwnRoutes({ t, updateSelectedTab, setUpdateSelectedTab, alert })}
        {/* {employeeCanViewTeam > 0 && TeamRoutes({ t })} */}
      </Route>
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
PunchInOutRoute.propTypes = {
  t: PropTypes.func
};
export default PunchInOutRoute;
